import { getAuthToken } from "../pb";

export const makeAuthenticatedRequest = async (
  url: string,
  options: RequestInit = {},
) => {
  const token = getAuthToken();
  console.log("token", token);

  const headers = {
    Authorization: `Bearer ${token}`,
    ...options.headers,
  };

  const response = await fetch(url, { ...options, headers });
  return response.json();
};

const SERVER_URL = import.meta.env.VITE_HONO_BACKEND;
//const SERVER_URL = 'https://e56d4db7-3a94-42d1-86ef-ec6c896a11b8-00-1y3ybrrxo2iw8.riker.replit.dev'

// Example usage
export const fetchStory = async () => {
  try {
    const response = await makeAuthenticatedRequest(SERVER_URL + "/api/story", {
      method: "POST",
      body: JSON.stringify({
        character: "dragon",
        location: "shopping mall",
      }),
    });

    return response;
  } catch (error) {
    console.error("Failed to fetch story:", error);
  }
};

export const fetchDebug = async (
  errorMessage: string,
  fileName: string,
  lineNumber: number,
  code: string,
) => {
  try {
    const response = await makeAuthenticatedRequest(SERVER_URL + "/api/debug", {
      method: "POST",
      body: JSON.stringify({
        errorMessage,
        fileName,
        lineNumber,
        code,
      }),
    });

    return response;
  } catch (error) {
    console.error("Failed to fetch debug:", error);
  }
};

export const fetchJoke = async () => {
  try {
    const response = await makeAuthenticatedRequest(SERVER_URL + "/api/joke", {
      method: "POST",
      body: JSON.stringify({
        topic: "potato",
      }),
    });

    return response;
  } catch (error) {
    console.error("Failed to fetch joke:", error);
  }
};


export const fetchTranslate = async (
  markdown: string,
  targetLanguage: string,
) => {
  try {
    const response = await makeAuthenticatedRequest(SERVER_URL + "/api/translate", {
      method: "POST",
      body: JSON.stringify({
        markdown,
        targetLanguage
      }),
    });

    return response;
  } catch (error) {
    console.error("Failed to fetch translation:", error);
  }
};

export const fetchGenerateMdx = async (
  context: string,
  instructions: string,
) => {
  try {
    const response = await makeAuthenticatedRequest(SERVER_URL + "/api/generate_mdx", {
      method: "POST",
      body: JSON.stringify({
        context,
        instructions
      }),
    });

    return response;
  } catch (error) {
    console.error("Failed to fetch mdx:", error);
  }
};

// Function to fetch joke

// export const fetchJoke = async () => {
//   const response = await fetch('https://75508219-3c5e-402b-886e-dcbc0c485b17-00-1wv0qnfpij24y.picard.replit.dev/api/joke', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   });

//   if (!response.ok) {
//     throw new Error('Network response was not ok');
//   }
//   return response.json();
// };
